import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import fr from 'facet-rest';
import Container from './Container';

const styles = () => ({
  root: {},
});

const Content = ({
  className,
  classes,
  resource,
}) => {
  return (
    <Container
      className={classNames(className, classes.root)}
      resource={resource}
    />
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(Content);
